<template>
  <section
    class="global-notification"
    data-test-id="global-notifications"
  >
    <AM3SnackbarContainer position="bottom-left" />
  </section>
</template>

<script>
import snackbarService from '@/composables/useSnackbar'
import AM3SnackbarContainer from '@/components/am3-generic/feedback/AM3SnackbarContainer.vue'

export default {
  name: 'GlobalNotification',
  components: {
    AM3SnackbarContainer,
  },
  data() {
    return {
      finishedPushMap: {},
      // Map AR notification types to AM3 types
      typeMap: {
        success: 'success',
        error: 'error',
        warning: 'warning',
        general: 'info',
        loading: 'loading',
      },
    }
  },
  created() {
    window.addEventListener('arNotificationPush', this.notificationPushEventPasser)
  },
  beforeUnmount() {
    window.removeEventListener('arNotificationPush', this.notificationPushEventPasser)
  },
  methods: {
    generateNotificationMessage(notification) {
      if (notification.link) {
        return `${notification.message} <a>${notification.link}</a>`
      }
      else {
        return notification.message
      }
    },
    notificationPushEventPasser(event) {
      this.handleNotificationPush(event.detail.payload, event.detail.hash)
    },
    triggerReceiveEvent(stamp, answer) {
      // It's already triggered
      if (this.finishedPushMap[stamp]) {
        return
      }
      this.finishedPushMap[stamp] = true

      // Trigger "arNotificationReceive" event, so our plugin can receive it
      const customEvent = new CustomEvent(
        'arNotificationReceive',
        {
          detail: {
            answer,
            hash: stamp,
          },
        },
      )
      window.dispatchEvent(customEvent)
    },
    fadeOutNotificationByStamp(stamp) {
      const { notification, index } = this.getNotificationByStamp(stamp)
      if (index === -1) {
        return
      }
      this.notifications[index] = {
        ...notification,
        opacity: '0',
        marginTop: `-${this.$refs['notification-card'][0].$el.clientHeight + 10}px`,
      }

      window.setTimeout(() => {
        this.removeNotificationByStamp(stamp)
      }, 300)
    },
    // Remove notification
    removeNotificationByStamp(stamp) {
      // Trigger receive event with answer as false
      this.triggerReceiveEvent(stamp, false)
      this.notifications = this.notifications.filter(notification => notification.stamp !== stamp)
    },
    notificationPushEventPasser(event) {
      this.handleNotificationPush(event.detail.payload, event.detail.hash)
    },
    // This will close notification before the timeout
    handleAnchorClick(stamp) {
      this.fadeOutNotificationByStamp(stamp)
      // Sometimes we need to know if promoter clicked link, if yes, answer is true
      this.triggerReceiveEvent(stamp, true)
    },
    handleClearClick(stamp) {
      this.fadeOutNotificationByStamp(stamp)
      this.triggerReceiveEvent(stamp, false)
    },
    handleNotificationPush({ type, message, title, link, width, timeout }, hash) {
      // Defaults: Success timeout is 6 sec. All others are 8.5 sec
      let finalTimeout = type === 'success' ? 6000 : 8500
      if (timeout) {
        finalTimeout = timeout
      }

      // Skip creating the notification if it's already visible on the page.
      // This happens when a component inadvertently sends a message twice.
      const alreadyShown = Boolean(this.finishedPushMap[hash])

      if (alreadyShown) {
        return
      }

      const notificationMessage = this.generateNotificationMessage({ message, link })

      // Convert to AM3 type
      const am3Type = this.typeMap[type] || 'info'

      // Show the notification using the service
      const id = snackbarService.show({
        message: notificationMessage,
        title,
        type: am3Type,
        duration: finalTimeout,
        dismissible: true,
        action: link
          ? {
              label: 'View',
              callback: () => this.triggerReceiveEvent(hash, true),
            }
          : undefined,
      })

      // Store the hash in the finished map when notification closes
      setTimeout(() => {
        this.triggerReceiveEvent(hash, false)
      }, finalTimeout)
    },
  },
}
</script>
